import { render, staticRenderFns } from "./version_alert.vue.js?vue&type=template&id=4c5d8a30&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./version_alert.vue?vue&type=template&id=4c5d8a30&vue3"
import script from "./version_alert.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./version_alert.vue?vue&type=script&lang=js&vue3"
export * from "./version_alert.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./version_alert.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports